import DataRoomDocumentsProvider from './DataRoomDocuments.provider';

export default DataRoomDocumentsProvider;
